import {defineNuxtPlugin, useRuntimeConfig} from '#app';
import {useStoryblokPreview} from '../composables/preview';
import Storyblok from 'storyblok-js-client';

export default defineNuxtPlugin({
  name: 'storyblok:preview',
  dependsOn: ['storyblok:init'],
  parallel: true,

  setup() {
    const config = useRuntimeConfig().public;

    const {isPreview} = useStoryblokPreview();

    const accessToken = config.storyblok.accessToken || config.storyblokConfig.accessToken;
    const previewAccessToken = config.storyblokConfig.accessTokenPreview || accessToken;

    watchEffect(() => {
      let api: Storyblok | undefined;

      if (!isPreview.value) {
        return;
      }

      try {
        api = useStoryblokApi();
      } catch {
        return;
      }

      if (isPreview.value) {
        if (import.meta.dev && !config.storyblokConfig.accessTokenPreview) {
          console.warn('[Storyblok] No `accessTokenPreview` found in runtime config, using `accessToken` instead');
        }

        api.accessToken = previewAccessToken;
      } else {
        api.accessToken = accessToken;
      }
    });
  },
});
